import { tv } from '~/utils/tv'

export const TagRootVariants = tv({
  base: `
  flex items-center justify-center h-small min-w-small rounded-pill px-twopulse gap-halfpulse max-w-[16rem]
  `,
  variants: {
    // @TODO adicionar os tokens quando eles forem atualizados
    variants: {
      onSale: 'bg-[var(--color-labeling-fill-onSale-default)]',
      principal: 'bg-[var(--color-labeling-fill-principal-default)]',
      secondary: 'bg-[var(--color-labeling-fill-secondary-default)]',
      clubeRaia: 'bg-[var(--color-labeling-fill-clubeRaia-default)]',
      clubeDrogasil: 'bg-[var(--color-labeling-fill-clubeDrogasil-default)]',
      assinatura: 'bg-[var(--color-labeling-fill-assinatura-default)]',
      medicamentoGeladeira:
        'bg-[var(--color-labeling-fill-medicamentoGeladeira-default)]',
      receitaObrigatoria:
        'bg-[var(--color-labeling-fill-receitaObrigatoria-default)]',
      generico: 'bg-[var(--color-labeling-fill-generico-default)]',
      referencia: 'bg-[var(--color-labeling-fill-referencia-default)]',
      similar: 'bg-[var(--color-labeling-fill-similar-default)]',
    },
  },
})
